/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free buffer recipe calculator. Pick a buffer — TBS, TBST, PBS, PBST, milk or BSA blocking — and scale the ingredient amounts to any volume you need.`)
};

const es_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de recetas de buffer gratuita. Elige un buffer — TBS, TBST, PBS, PBST, bloqueo con leche o BSA — y escala las cantidades de ingredientes al volumen que necesites.`)
};

const de_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Pufferrezept-Rechner. Wählen Sie einen Puffer — TBS, TBST, PBS, PBST, Milch- oder BSA-Blockierpuffer — und skalieren Sie die Zutatenmengen auf das gewünschte Volumen.`)
};

const nl_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis buffer-receptcalculator. Kies een buffer — TBS, TBST, PBS, PBST, melk- of BSA-blokkering — en schaal de ingrediënthoeveelheden naar elk gewenst volume.`)
};

const fr_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de recettes de tampon gratuit. Choisissez un tampon — TBS, TBST, PBS, PBST, blocage au lait ou à la BSA — et adaptez les quantités d'ingrédients au volume voulu.`)
};

const it_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito di ricette per buffer. Scegli un buffer — TBS, TBST, PBS, PBST, latte o BSA per il blocco — e scala le quantità degli ingredienti al volume che ti serve.`)
};

const pt_br2_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de receitas de tampão. Escolha um tampão — TBS, TBST, PBS, PBST, bloqueio com leite ou BSA — e dimensione as quantidades de ingredientes para o volume que você precisar.`)
};

const pt_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de receitas de tampão gratuita. Escolha um tampão — TBS, TBST, PBS, PBST, bloqueio com leite ou BSA — e escale as quantidades dos ingredientes para o volume que precisar.`)
};

const ja_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のバッファーレシピ計算機です。TBS、TBST、PBS、PBST、ミルクまたはBSAブロッキングバッファーを選び、必要な量に試薬量をスケーリングします。`)
};

const zh_buf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费缓冲液配方计算器。选择缓冲液——TBS、TBST、PBS、PBST、脱脂奶或 BSA 封闭液——并将所需成分用量放大至任意体积。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_meta_description", locale)
	if (locale === "en") return en_buf_meta_description(inputs)
	if (locale === "es") return es_buf_meta_description(inputs)
	if (locale === "de") return de_buf_meta_description(inputs)
	if (locale === "nl") return nl_buf_meta_description(inputs)
	if (locale === "fr") return fr_buf_meta_description(inputs)
	if (locale === "it") return it_buf_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_buf_meta_description(inputs)
	if (locale === "pt") return pt_buf_meta_description(inputs)
	if (locale === "ja") return ja_buf_meta_description(inputs)
	return zh_buf_meta_description(inputs)
};